export default {
  superAdmin: 'super_admin',
  admin: 'admin',
  moderator: 'moderator',
  user: 'user'
};
